import $ from "jquery";
import "bootstrap-notify";
import Seed from "DMS/Seed/All";
import { notify } from "DMS/Utils/modal";
import googleInit from "DMS/Utils/GoogleMapLoader";
import * as GoogleMapInfoPanel from "DMS/Utils/GoogleMapInfoPanel";
import * as GoogleMapTour from "DMS/Utils/GoogleMapTour";
import CustomMarkerClass from "DMS/Utils/CustomMarkerClass";
import { removeInfoPanel, recenterMap, changeMapWidth, getPanelForTechOrFileAddressData } from "DMS/Controllers/geolocController";
let urlPrefix = "";
let isPlanning = false;
// Fonctions d'initialisation
async function initMap() {
    window.map = new google.maps.Map(Seed.Tab.GetFrame().find('.googleMap')[0], {
        center: { lat: 48.866667, lng: 2.333333 },
        zoom: 8,
        gestureHandling: 'greedy'
    });
    // remove load effect when google map has finished to load
    google.maps.event.addListenerOnce(window.map, 'idle', () => removeLoadEffect());
    return Promise.resolve();
}
function reinitBound(data) {
    let i = 0;
    for (let currentData in data['techData']) {
        if (data['techData'][currentData]['latitude'] !== null && data['techData'][currentData]['longitude'] !== null) {
            bounds.extend(new google.maps.LatLng(data['techData'][currentData]['latitude'], data['techData'][currentData]['longitude']));
            i++;
        }
    }
    if (i > 0) {
        window.map.fitBounds(bounds);
        if (window.map.getZoom() >= 16) {
            window.map.setZoom(15);
        }
    }
}
//Fonctions d'hydratation de l'objet map
async function setTechsMarkers(techDataObject, origin) {
    bounds = new google.maps.LatLngBounds();
    infowindow = new google.maps.InfoWindow();
    window.marker = [];
    var duplicatesIdentifier = [];
    if (techDataObject !== undefined && $(techDataObject.techData).length) {
        let i = 0;
        for (let tech in techDataObject['techData']) {
            // ne crée pas de marker s'il n'y a pas de latitude ni de longitude
            if (techDataObject['techData'][tech]['latitude'] !== null && techDataObject['techData'][tech]['longitude'] !== null) {
                getDuplicates(techDataObject['techData'][tech], tech, duplicatesIdentifier);
                let currentMarker = hydrateTechsMarkers(techDataObject['techData'][tech], i);
                bounds.extend(currentMarker.position);
                google.maps.event.addListener(currentMarker, 'click', () => {
                    hydrateTechInfoWindow(techDataObject['techData'][tech], origin, currentMarker);
                });
                i++;
            }
        }
        parseDuplicate(duplicatesIdentifier, techDataObject['techData']).then(setUpCustomMarker);
        if (i > 0) {
            window.map.fitBounds(bounds);
            if (window.map.getZoom() >= 16) {
                window.map.setZoom(15);
            }
        }
        google.maps.event.addListener(infowindow, 'closeclick', (marker2) => reinitBound(techDataObject));
    }
    else {
        removeLoadEffect();
        notify(noData);
        throw new Error('noData');
    }
}
function setUpCustomMarker(customMarkerData) {
    for (let mark in customMarkerData) {
        let latLng = mark.split('_');
        let markerPos = new google.maps.LatLng(latLng[0], latLng[1]);
        window.marker[mark] = new (CustomMarkerClass())(markerPos, window.map, 'users', { size: 18, margin: 6 });
        google.maps.event.addListener(window.marker[mark], 'click', () => {
            if (typeof $('.gm-style-iw') !== 'undefined') {
                $('.gm-style-iw').parent().remove();
            }
            let displayIt = true;
            if ($("#information_panel").length > 0) {
                if (typeof $("#information_panel").data("mark") !== 'undefined') {
                    if ($("#information_panel").data("mark") == mark) {
                        displayIt = false;
                    }
                }
                removeInfoPanel();
            }
            if (displayIt) {
                GoogleMapInfoPanel.splitDataToDisplay(customMarkerData[mark], 'location').then((splitData) => GoogleMapInfoPanel.createInformationPanelContainer(splitData, 'location').then(() => {
                    $("#information_panel").data("mark", mark);
                }));
            }
            else {
                changeMapWidth().then(recenterMap);
            }
        });
    }
}
/* context = 'position', 'depart', 'arrivee', 'both' (depart + arrivee) ou 'file */
function hydrateTechInfoWindow(techDataObject, context, currentMarker) {
    let formattedContent = getPanelForTechOrFileAddressData(techDataObject, context);
    infowindow.setContent(formattedContent);
    infowindow.open(window.map, currentMarker);
    window.map.setCenter(currentMarker.getPosition());
    // supprime le panneau indiquant la liste des techniciens localises a la meme adresse
    removeInfoPanel().then(changeMapWidth).then(recenterMap);
}
function hydrateTechsMarkers(techDataObject, i) {
    let marker2 = new google.maps.Marker({
        position: new google.maps.LatLng(techDataObject['latitude'], techDataObject['longitude']),
        label: techDataObject['bbmindex'],
        title: techDataObject['codetechnicien'],
        zIndex: i,
        map: window.map
    });
    marker2.set('id', 'marker' + techDataObject['bbmindex']);
    window.marker.push(marker2);
    return marker2;
}
function getDuplicates(currentData, techCode, duplicatesIdentifier) {
    duplicatesIdentifier[currentData['latitude'] + '_' + currentData['longitude']] =
        typeof duplicatesIdentifier[currentData['latitude'] + '_' + currentData['longitude']] !== 'undefined' ?
            duplicatesIdentifier[currentData['latitude'] + '_' + currentData['longitude']] + ', ' + techCode : techCode;
}
async function parseDuplicate(duplicatesIdentifier, techData) {
    window.duplicateLoc = [];
    for (let duplicate in duplicatesIdentifier) {
        let splitArr = duplicatesIdentifier[duplicate].split(', ', 50);
        if (splitArr.length > 1) {
            duplicateLoc[duplicate] = [];
            for (let techCode in splitArr)
                duplicateLoc[duplicate][splitArr[techCode]] = techData[splitArr[techCode]];
        }
    }
    return duplicateLoc;
}
// entree :
//  
// origin = 'depart' ou 'arrivee'
// filters =
// { secteur: { value: "",
//              "table-to-join": "xsecteur",
//              operator: "eq" },
//   nomtechnicien: { value: "",
//                    "table-to-join": "xtechnicien",
//                    operator: "contains" },
//   competence: { value: "",
//                 "table-to-join": "techniciencompetence",
//                 operator: "eq" } }
// 
// sortie :
//
// { 'techData': [ { adresse_1: [ { 'bbmindex': bbmindex,
//                                  'codetechnicien': codetechnicien,
//                                  'nomtechnicien': nomtechnicien },
//                                { ... } ],
//                 { adresse_2: [ ... ] } ] }
//
async function getTechList(origin, filters = '') {
    let dataToSend = 'origin=position';
    let filterObject = {};
    if (filters !== '') {
        filterObject = {
            'competence': filters.competence,
            'nomtechnicien': filters.nomtechnicien,
            'secteur': filters.secteur
        };
        dataToSend = 'filters=' + JSON.stringify(filterObject) + '&origin=' + origin;
    }
    return Seed.Ajax.Post({
        url: urlPrefix + "RequestBuilder/StrategyIndex.php",
        data: dataToSend,
        json: true,
        async: true
    });
}
// @todo : cette fonction est utilisée ?
async function getTechPosInTour(bbmindex) {
    return Seed.Ajax.Post({
        url: urlPrefix + "RequestBuilder/StrategyIndex.php",
        data: {
            'filters': filters,
            'action': 'revert',
            'origin': origin
        },
        json: true,
        async: true,
    });
}
// recuperation des donnees technicien et tournee
// depuis la base de donnees
// filters = { 'date': chosenDate, 'bbmindex': techBbmindex }
async function getTechTour(filters) {
    return Seed.Ajax.Post({
        url: urlPrefix + "RequestBuilder/StrategyIndex.php",
        data: {
            'filters': filters,
            'action': 'geocode',
            'origin': 'tour'
        },
        json: true,
        async: true
    });
}
async function getTechAdresses(techData) {
    return Seed.Ajax.Post({
        url: urlPrefix + "WebServices/index.php",
        data: {
            'tech_data': techData.techData,
            'action': 'revert'
        },
        json: true,
        async: true
    });
}
// entree :
//  
// origin = 'depart' ou 'arrivee'
// techData =
// { 'techData': [ { adresse_1: [ { 'bbmindex': bbmindex,
//                                  'codetechnicien': codetechnicien,
//                                  'nomtechnicien': nomtechnicien },
//                                { ... } ],
//                 { adresse_2: [ ... ] } ] }
//
async function getTechGeocode(techData, origin) {
    return Seed.Ajax.Post({
        url: urlPrefix + "WebServices/index.php",
        data: {
            'tech_data': techData.techData,
            'action': 'geocode',
            'origin': origin
        },
        json: true,
        async: true
    });
}
// @todo : en faire un modèle de données... c'est pas ce commentaire qui va arranger les choses
// recupere les latitudes et longitudes d'apres les adresses ou l'inverse
// et renvoie l'objet fourni en entree (donnees technicien + tournee)
// avec ces donnes en +. Le format de la sortie est different !
// 
// !! donnees entree : adresse ; donnees sortie : address !
// 
// entree :
// { 'techData' => { 'tourDate': $tourDateEnglish,            
//                   'tech': $techData_array['nomtechnicien'],
//                   'adressedepart': $techData_array['adressedepart'],
//                   'adressearrivee': $techData_array['adressearrivee'],
//                   'tech_data': { 'bbmindex': $techData_array['bbmindex'],
//                                  'codetechnicien': $techData_array['codetechnicien'],
//                                  'nomtechnicien': $techData_array['nomtechnicien'],
//                                  'latitude': $techData_array['latitude'],
//                                  'longitude': $techData_array['longitude'] },
//                   'files': [ { 'nomtechnicien': $file_array['nomtechnicien'],
//                                'numdossier': $file_array['numdossier'],
//                                'nomclientlivraison': $file_array['nomclientlivraison'],
//                                'adresse': $file_array['adresselivraison'] . ', ' . $file_array['codepostallivraison'] . ' ' . $file_array['villelivraison'],
//                                'prevule': $file_array['datedebut'],
//                                'typeentree': $file_array['typeentree'],
//                                'tempsestime': $durationInSeconds } ]
//                 }
// }
// 
// sortie :
// { 'tourDate': $tourDateEnglish,            
//   'tech': $techData_array['nomtechnicien'],
//   'adressedepart': { 'numdossier': null,
//                      'nomclientlivraison': null,
//                      'address': $techData_array['adressedepart'],
//                      'latitude':
//                      'longitude':
//                      'prevule': null,
//                      'typeentree': null,
//                      'tempsestime': null },
//   'adressearrivee': { 'numdossier': null,
//                       'nomclientlivraison': null,
//                       'address': $techData_array['adressearrivee'],
//                       'latitude':
//                       'longitude':
//                       'prevule': null,
//                       'typeentree': null,
//                       'tempsestime': null },
//   'tech_pos': { 'bbmindex': $techData_array['bbmindex'],
//                 'codetechnicien': $techData_array['codetechnicien'],
//                 'nomtechnicien': $techData_array['nomtechnicien'],
//                 'latitude': $techData_array['latitude'],
//                 'longitude': $techData_array['longitude']
//                 'address': },
//   'file_0': { 'numdossier': $file_array['numdossier'],
//               'nomclientlivraison': $file_array['nomclientlivraison'],
//               'address': $file_array['adresselivraison'] . ', ' . $file_array['codepostallivraison'] . ' ' . $file_array['villelivraison'],
//               'latitude':
//               'longitude':
//               'prevule': $file_array['datedebut'],
//               'typeentree': $file_array['typeentree'],
//               'tempsestime': $durationInSeconds },
//   'file_1': { ... }
// }
async function getTourGeocode(tourData) {
    return new Promise((resolve, reject) => {
        Seed.Ajax.Post({
            url: urlPrefix + "WebServices/index.php",
            data: {
                'tech_data': tourData.techData,
                'action': 'geocodetour'
            },
            json: true,
            async: true,
            success: (tourObject) => {
                if (tourObject.tourData == 'noTour'
                    || tourObject.tourData == 'selectTechnician'
                    || (typeof tourObject.isAddressValid != 'undefined' && !tourObject.isAddressValid)) {
                    let rejectionReason = tourObject.tourData == 'noTour' || tourObject.tourData == 'selectTechnician' ? tourObject.tourData : 'wrongTourAddress';
                    reject(rejectionReason);
                }
                else {
                    resolve(tourObject.tourData);
                }
            }
        });
    });
}
async function getDirections(tourObject) {
    return new Promise((resolve, reject) => {
        Seed.Ajax.Post({
            url: urlPrefix + "WebServices/index.php",
            data: {
                'tourObject': tourObject,
                'action': 'directions'
            },
            json: true,
            async: true,
            success: (directionsObject) => {
                if (typeof directionsObject.directionsRequestStatus != 'undefined' && directionsObject.directionsRequestStatus != 'OK') {
                    reject('directionsNoResult');
                }
                else {
                    resolve(directionsObject.directionsData);
                }
            }
        });
    });
}
async function treatTourData(directionsData) {
    return new Promise(function (resolve) {
        GoogleMapTour.processTourTreatment(directionsData);
        resolve();
    });
}
// Function reprenant le concept du pattern strategy grosso modo
//
// entree :
// origin = 'init' ou 'position' ou 'depart' ou 'arrivee' ou 'tour'
// filters = different en fonction de origin (commentaires dans fonction)
export function strategyGoogleMap(origin = 'position', filters = '') {
    switch (origin) {
        case 'init':
            return getMapForTechPos(origin, filters);
        case 'position':
            return getMapForTechPosWithFilters(origin, filters);
        case 'depart':
        case 'arrivee':
            return getMapForStartOrEndPos(origin, filters);
        case 'tour':
            return getMapForTour(filters);
    }
}
export async function createMap() {
    await loadEffect();
    await googleInit(urlPrefix);
    await initMap();
    google.maps.event.addListenerOnce(window.map, 'idle', removeLoadEffect);
    hideTabElems();
    changeResearchButton();
    removeLoadEffect();
}
async function getMapForTechPos(origin, filters = '') {
    await loadEffect();
    await googleInit(urlPrefix);
    await initMap();
    let techData = await getTechList(origin, filters);
    let techDataObject = await getTechAdresses(techData);
    await setTechsMarkers(techDataObject, 'position').catch((error) => console.log(error.message));
    google.maps.event.addListenerOnce(window.map, 'idle', removeLoadEffect);
    hideTabElems();
    changeResearchButton();
}
async function getMapForTechPosWithFilters(origin, filters = '') {
    await loadEffect();
    google.maps.event.addListenerOnce(window.map, 'idle', removeLoadEffect);
    let techData = await getTechList(origin, filters);
    let techDataObject = await getTechAdresses(techData);
    if (techData && techDataObject) {
        await setTechsMarkers(techDataObject, origin).catch((error) => console.log(error.message));
    }
    hideTabElems();
    removeTourData();
    changeResearchButton();
    removeLoadEffect();
}
// affiche la carte en indiquant les positions de depart ou d'arrivee
// 
// entree :
//  
// origin = 'depart' ou 'arrivee'
// filters =
// { secteur: { value: "",
//              "table-to-join": "xsecteur",
//              operator: "eq" },
//   nomtechnicien: { value: "",
//                    "table-to-join": "xtechnicien",
//                    operator: "contains" },
//   competence: { value: "",
//                 "table-to-join": "techniciencompetence",
//                 operator: "eq" } }
// 
// sortie :
async function getMapForStartOrEndPos(origin, filters = '') {
    return loadEffect()
        .then(() => {
        google.maps.event.addListenerOnce(window.map, 'idle', () => removeLoadEffect());
    })
        .then(() => getTechList(origin, filters))
        .then((techData) => getTechGeocode(techData, origin))
        .then((techDataObject) => setTechsMarkers(techDataObject, origin).catch((error) => console.log(error.message)))
        .then(removeTourData)
        .then(removeLoadEffect);
}
// filters = { 'date': chosenDate, 'bbmindex': techBbmindex }
function getMapForTour(filters = '') {
    return loadEffect()
        .then(() => {
        if (!isPlanning)
            return removeInfoPanel();
    })
        .then(() => google.maps.event.addListenerOnce(window.map, 'idle', () => removeLoadEffect()))
        .then(() => {
        // recuperation des donnees technicien et tournee
        // depuis la base de donnees
        // 
        // entree : filters = { 'date': chosenDate, 'bbmindex': techBbmindex }
        // sortie :
        // [ { 'techData' => { 'tourDate': $tourDateEnglish,            
        //                     'tech': $techData_array['nomtechnicien'],
        //                     'adressedepart': $techData_array['adressedepart'],
        //                     'adressearrivee': $techData_array['adressearrivee'],
        //                     'tech_data': { 'bbmindex': $techData_array['bbmindex'],
        //                                    'codetechnicien': $techData_array['codetechnicien'],
        //                                    'nomtechnicien': $techData_array['nomtechnicien'],
        //                                    'latitude': $techData_array['latitude'],
        //                                    'longitude': $techData_array['longitude'] },
        //                     'files': [ { 'nomtechnicien': $file_array['nomtechnicien'],
        //                                  'numdossier': $file_array['numdossier'],
        //                                  'nomclientlivraison': $file_array['nomclientlivraison'],
        //                                  'adresse': $file_array['adresselivraison'] . ', ' . $file_array['codepostallivraison'] . ' ' . $file_array['villelivraison'],
        //                                  'prevule': $file_array['datedebut'],
        //                                  'typeentree': $file_array['typeentree'],
        //                                  'tempsestime': $durationInSeconds } ]
        //                   }
        // } ]
        return getTechTour(filters);
    })
        // on affiche la position courante du technicien
        .then((techDataObject) => {
        return new Promise(function (resolve, reject) {
            if (typeof techDataObject['techData']['tech'] !== 'undefined' && techDataObject['techData']['tech'] !== '') {
                let tech_data = { 'techData': {} };
                tech_data['techData'][techDataObject['techData']['tech']] = techDataObject['techData']['tech_data'];
                setTechsMarkers(tech_data, 'position')
                    .then(resolve(techDataObject)).catch((error) => console.log(error.message));
            }
            else {
                reject('selectTechnician');
            }
        });
    })
        .then(getTourGeocode)
        .then(getDirections)
        .then(treatTourData)
        .then(removeLoadEffect).catch((err) => {
        removeLoadEffect();
        notify(window[err]);
    });
}
//Functions pour l'ergonomie
async function loadEffect() {
    $('body').append('<div style="" id="loadingDiv"><div class="loader">Loading...</div></div>');
}
function removeTourData() {
    let panel = document.getElementById('span-for-data');
    if (panel != null) {
        panel.innerHTML = '';
    }
}
export async function removeLoadEffect() {
    return new Promise((resolve) => {
        $("#loadingDiv").remove();
        resolve();
    });
}
function hideTabElems() {
    let windowContent = $('#geoloc-body');
    windowContent.find('#undefined_tab').css('visibility', 'hidden');
    let tabContent = windowContent.find('.tab_content')[0];
    $(tabContent).css('display', 'none');
}
function changeResearchButton() {
    let researchButton = Seed.Tab.GetFrame().find('#nomdiv > parent > div.panel.panel-primary > div.panel-collapse > div.panel-footer > div.row > div.col-lg-12').children('button')[0];
    $(researchButton).click(() => refreshAll());
    let reinitButton = Seed.Tab.GetFrame().find('#nomdiv > parent > div.panel.panel-primary > div.panel-collapse > div.panel-footer > div.row > div.col-lg-12').children('button')[1];
    $(reinitButton).click(() => {
        clearFilters();
        refreshAll(false);
    });
}
export function changeUrlPrefix(urlP) {
    urlPrefix = urlP;
}
export function changeIsPlanning(p) {
    isPlanning = p;
}
//# sourceMappingURL=GoogleMapStarter.js.map